/** Pure use-case search + status filter for the Coverage tab. */

export function usecaseMatches(uc, query) {
  var _uc$title, _uc$description;
  var q = query.trim().toLowerCase();
  if (q === '') return true;
  return uc.id.toLowerCase().includes(q) || ((_uc$title = uc.title) !== null && _uc$title !== void 0 ? _uc$title : '').toLowerCase().includes(q) || ((_uc$description = uc.description) !== null && _uc$description !== void 0 ? _uc$description : '').toLowerCase().includes(q);
}

/** null = all statuses. Status comes from the ACTIVE aspect's rollup. */
export function usecaseStatusMatches(status, filter) {
  return filter === null || status === filter;
}